/* Copyright (c) 2017 Backpack Health LLC */

import { apiRequest } from './apiRequest';

export interface ListItem {
  id: number;
  name: string;
  key: string;
  code: string;
}

const api = {
  birthSex: function listBirthSex() {
    return apiRequest('get', 'lists/birthSex');
  },
  gender: function listGender() {
    return apiRequest('get', 'lists/gender');
  },
  locale: function listLocale() {
    return apiRequest('get', 'lists/locale');
  },
  profileState: function listProfileState() {
    return apiRequest('get', 'lists/profileState');
  },
  category: function listCategory() {
    return apiRequest('get', 'lists/category');
  },
  country: function listCountry() {
    return apiRequest('get', 'lists/country');
  },
  residenceCountry: () => {
    return apiRequest('get', 'lists/residenceCountry');
  },
  residenceState: () => {
    return apiRequest('get', 'lists/residenceState');
  },
  localeMedli: function listLocaleMedli() {
    return apiRequest('get', 'lists/localeMedli');
  },
  frequency: function listCountry() {
    return apiRequest('get', 'lists/frequency');
  },
  colorTheme: function listColorTheme() {
    return apiRequest('get', 'lists/colorTheme');
  },
  shareCardColors: function listShareCardColors() {
    return apiRequest('get', 'lists/colorShareCard');
  },
  cancelReason: function listCancelReason() {
    return apiRequest('get', 'lists/cancelReason');
  },
};

const listsApi = {
  birthSex() {
    return api.birthSex()()
    .then(res => res.data.data);
  },

  gender() {
    return api.gender()()
    .then(res => res.data.data);
  },

  locale() {
    return api.locale()()
    .then(res => res.data.data);
  },

  profileState() {
    return api.profileState()()
    .then(res => res.data.data);
  },

  category() {
    return api.category()()
    .then(res => res.data.data);
  },

  country() {
    return api.country()()
    .then(res => res.data.data);
  },

  residenceCountry(): Promise<ListItem[]> {
    return api.residenceCountry()()
    .then(res => res.data.data);
  },

  residenceState(): Promise<ListItem[]> {
    return api.residenceState()()
    .then(res => res.data.data);
  },

  localeMedli() {
    return api.localeMedli()()
    .then(res => res.data.data);
  },

  frequency() {
    return api.frequency()()
    .then(res => res.data.data);
  },

  colorTheme() {
    return api.colorTheme()()
    .then(res => res.data.data);
  },

  shareCardColors() {
    return api.shareCardColors()()
    .then(res => res.data.data);
  },

  cancelReason() {
    return api.cancelReason()()
    .then(res => res.data.data);
  },
};

export default listsApi;
